module.exports = "/_next/static/images/PersonalizedCustomerEngagement-9ef7d20ade335dfbcebfd4b07ca591f0.webp";